import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useParcelSubscribeDiscoveryPage = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.IParcelSubscribeDiscoveryPageRequestData) => {
        const response = await send<
            Types.IParcelSubscribeDiscoveryPageRequestData,
            Types.IParcelSubscribeDiscoveryPageResponseData
        >({
            ID: 73010,
            responses: [73011, 73012],
            description: 'Mystery Parcel Discovery Page subscription',
            ...options
        });

        return response;
    }, [send]);
};
